// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-reset-card{width:100%;max-width:400px}`, "",{"version":3,"sources":["webpack://./src/pages/PasswordReset/style.scss"],"names":[],"mappings":"AAAA,qBACE,UAAA,CACA,eAAA","sourcesContent":[".password-reset-card {\n  width: 100%;\n  max-width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
